import { useCallback } from 'react';
import { useDeviceInfo } from '@/hooks/useDeviceInfo';
import { FooterLogic } from './logic';

/**
 * Returns a function that cases a sentence-case label for the current Ionic
 * mode: title case in ios mode, as written in md mode. For labels that aren't
 * rendered through `SmartCaseButton`, such as a prop on another component.
 */
export function useSmartCase() {
  const { isIonModeIOS } = useDeviceInfo();
  return useCallback(
    (label: string) => FooterLogic.smartCase(label, isIonModeIOS),
    [isIonModeIOS]
  );
}
